"use client";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  CloseButton,
} from "@stadium/ui/src/components/ModalNew/utils";

import useRouter from "@stadium/hooks/lib/use-custom-route";

import { InternalButton } from "@sharedComponents/buttons";

import { externalRoutes } from "@constants/external-routes";
import { useWorkspaceContext } from "@contexts/workspace-context";

import styles from "./main.module.scss";

export const ADD_LOGO_EXIT_MODAL_BODY =
  "If you exit now, we'll save the products but your designs won't be saved. You can come back anytime to continue editing your collection.";

const ExitCreateSwagConfirmModal = ({ closeModal, bodyText = ADD_LOGO_EXIT_MODAL_BODY }) => {
  const { replace } = useRouter();
  const { getDashboardUrlWithCurrentWorkspaceSlug } = useWorkspaceContext();

  const handleConfirmExit = () => {
    closeModal();
    replace(getDashboardUrlWithCurrentWorkspaceSlug(externalRoutes.lockerDashboard()));
  };

  return (
    <Modal closeModal={closeModal} newModal>
      <ModalDialog className={styles.exitConfirmDialog}>
        <ModalContent>
          <ModalHeader>
            Are you sure you want to exit?
            <CloseButton onClick={closeModal} autoFocus />
          </ModalHeader>
          <ModalBody>
            <p className={styles.exitConfirmDescription}>{bodyText}</p>
            <div className={styles.exitConfirmFooter}>
              <InternalButton
                styleType="primary"
                className={styles.exitConfirmCta}
                onClick={handleConfirmExit}
                aria-label="Exit"
              >
                Exit
              </InternalButton>
            </div>
          </ModalBody>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default ExitCreateSwagConfirmModal;
